if (!customElements.get("product-specs")) {
  class ComponentProductSpecs extends HTMLElement {
    constructor() {
      super();

      this.hasVariantSpecs = this.dataset.hasVariantSpecs === "true";
      if (this.hasVariantSpecs) {
        this.mainElement = document.querySelector(".product-main-element");
        this.mainElement.addEventListener("variantChange", (event) => {
          this.showSpec(`spec-variant-${event.detail.variant.id}`);
        });
      }
    }

    showSpec(specId) {
      this.querySelectorAll(".spec-detail").forEach((spec) =>
        spec.classList.remove("active")
      );
      this.closest(".content")
        .querySelector(`.spec-detail.${specId}`)
        .classList.add("active");
    }
  }
  customElements.define("product-specs", ComponentProductSpecs);
}
